exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rank-list .rank-item[data-v-61caeab5] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 50px;\n  padding: 0 20px;\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n.rank-list .rank-item[data-v-61caeab5]:last-child {\n  margin-bottom: 0;\n}\n.rank-list .rank-item .left-area .rank[data-v-61caeab5] {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  color: #fff;\n}\n.rank-list .rank-item .left-area .class-name[data-v-61caeab5] {\n  margin-left: 13px;\n  font-size: 16px;\n  font-weight: bold;\n}\n", ""]);

// exports
